angular.module('moebiusProadapt').controller('ctrlDashboard',
    ['$scope', '$http', '$location', '$route', '$rootScope', 'mbsResolver', 'dashboardResolver', function($scope, $http, $location, $route, $rootScope, mbsResolver, dashboardResolver){

    console.log('ctrlDashboard bootstrap');
    console.log(dashboardResolver);


    /** @var Array */
    $scope.eti_list = dashboardResolver.eti_list;

    /** @var Array */
    var chunkedEti = null;

    // console.log(resolve);
    console.log('eti_list');
    console.log($scope.eti_list);


    _.each($scope.eti_list, function(eti) {
        $route.current.params.id = eti.id;
        console.log('call mbsResolver.etiConfiguration ' + eti.id);
        mbsResolver.etiConfiguration('etude-instance/configuration', {id: null});
    });

    /**
     * @return Array
     */
    $scope.getChunkEti = function()
    {
        if(!chunkedEti)
        {
            var size = 4;
            chunkedEti = [];

            var tmp = _.partition($scope.eti_list, function(eti)
            {
                return true;
            });

            _.each(tmp, function(value, idx)
            {
                while (value.length > 0) {
                    chunkedEti.push(value.splice(0, size));
                }
            });
        }
        return chunkedEti;
    }

    $scope.loadingEtude = [];

    /**
     * @param Object eti
     */
    $scope.openInstance = function(eti)
    {
        if($scope.loadingEtude.includes(true)){ // already loading an etude
            return;
        }

        $location.path('/etude/' +eti.id +'');
        $scope.loadingEtude[eti.id] = true;
    };

}]
);
//
//     /**
//      * @return Array
//      */
//     $scope.getChunkEti = function()
//     {
//         if(!chunkedEti)
//         {
//             var tmp = _.partition($scope.eti_list, function(eti)
//             {
//                 return eti.wdefArray.profile == 'EMEIA';
//             });
//
//             var size = 4;
//             chunkedEti = [];
//
//             _.each(tmp, function(value, idx)
//             {
//                 while (value.length > 0) {
//                     chunkedEti.push(value.splice(0, size));
//                 }
//             });
//         }
//         return chunkedEti;
//     };
//
//     /**
//      * @param Object eti
//      */
//     $scope.openInstance = function(eti)
//     {
//         $location.path('/workflow/' +eti.id +'/youractions');
//     };
//
// });



// WEBPACK FOOTER //
// ./resources/assets/js/controllers/dashboard.js